import React, {useContext, useEffect, useRef, useState} from "react";
import SideNav from "../components/SideNav";
import WeekCard from "../components/WeekCard";
import MobileHeader from "../components/mobile/MobileHeader";
import BottomNav from "../components/mobile/BottomNav";
import {AppContext} from "../App";
import {useHistory} from "react-router-dom";
import {CardActionArea, IconButton, Snackbar} from "@material-ui/core";
import {BASE_URL} from '../env.json';
import {AppService} from "../services/app.service";
import CloseIcon from "@material-ui/icons/Close";

function Home() {

    const cards: any = [];
    const [alertMsg, setAlertMsg] = useState<string>("")
    const context = useContext(AppContext);
    const appContent = context.appContent;
    let history = useHistory();
    const activeWeekRef = useRef<HTMLButtonElement | null>(null);


    //redirect to intro page when lesson number is Zero
    if (context.currentWeekNo === 0) {
        history.push(`/intro/${context.deviceId}/${context.recoveryId}`);
    }

    const [isMobile, setIsMobile] = useState(false);
    const checkIsMobile = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        if (
            userAgent.includes('android') ||
            userAgent.includes('iphone') ||
            userAgent.includes('ipad') ||
            userAgent.includes('ipod')
        ) {
            setIsMobile(true);
            console.log("ITS MOBILE")
        } else {
            setIsMobile(false);
            console.log("ITS DESKTOP")
        }
    };

    // Scroll to the active week when the component mounts
    useEffect(() => {
        const userAgent = navigator.userAgent.toLowerCase();
        if (
            userAgent.includes('android') ||
            userAgent.includes('iphone') ||
            userAgent.includes('ipad') ||
            userAgent.includes('ipod')
        ) {
            setIsMobile(true);
            if (activeWeekRef.current) {
                activeWeekRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'center',
                });
            }
        } else {
            setIsMobile(false);
        }



    }, [activeWeekRef]);


    if(appContent !== undefined) {
        for (let i = 0; i < appContent.length; i++){
            if(!appContent[i].is_a_Screen_Intro) {


                let backgroundImage: string = appContent[i].background;

                let isLock: boolean;
                let lockDetail: string = '';

                if(Number(context.currentWeekNo) >= appContent[i].ordering_number) {
                    isLock = false;
                    lockDetail = ``
                } else {
                    isLock = true;
                    if(!(Number(context.currentWeekNo) >= appContent[i].ordering_number))
                        lockDetail = `Finish Week ${appContent[i].ordering_number - 1} to access this content!`
                }

                let progressLabel: string;
                progressLabel = getWeekProgress(Number(appContent[i].ordering_number), appContent[i].tasks?.length)
                let buttonIdLabel: string = (Number(context.currentWeekNo) === appContent[i].ordering_number) ? `active-week` : `week-${appContent[i].ordering_number}`
                cards.push(
                    <CardActionArea className={'card-action'} key={appContent[i].id}
                        onClick={()=>{
                            if(Number(context.currentWeekNo) >= appContent[i].ordering_number) {
                                context.setActiveWeekTaskList(appContent[i]);
                                context.setCurrentWeekNo(appContent[i].ordering_number);
                                history.push(`/task-list/${context.deviceId}/${context.recoveryId}`);
                            }
                            else
                            {
                                setAlertMsg(`This week is locked. Complete Week ${context.currentWeekNo} first.`);
                                setOpen(true);
                            }
                        }}
                        ref={buttonIdLabel === "active-week" ? activeWeekRef : null}
                    >
                        <WeekCard
                            key={appContent[i].id}
                            isLock={isLock}
                            weekNo={`WEEK 0${appContent[i].ordering_number}`}
                            lockDetail={lockDetail}
                            backgroundImage={backgroundImage}
                            progressLabel= {progressLabel}
                            weekTitle={appContent[i].title}
                            taskLabel={`${appContent[i].tasks?.length} TASKS`}/>
                    </CardActionArea>
                )
            }

        }
    }

    const appService = new AppService();
    useEffect(()=> {
        async function getUserData(){
            const userData = await appService.fetchData(BASE_URL + `recovery2/recovery2-user/${context.recoveryId}/`);
            if(userData !== undefined) {
                // console.log(userData)
                context.setCurrentWeekNo(userData.data.current_task.week.ordering_number)
                context.setCurrentTaskNo(userData.data.current_task.ordering_number)
                context.setIsCompleted(userData.data.program_complete)
            }
        }
        getUserData();
    }, []);

    const [open, setOpen] = useState<boolean>(false)
    const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };


    function getWeekProgress(cardWeekNo: number, taskCount: number) {
        // in this screen Current WeekNo and Task Number are from user's data
        if((Number(context.currentWeekNo) > cardWeekNo) || context.isCompleted) {
            return 'COMPLETED'
        } else if (cardWeekNo ===  Number(context.currentWeekNo)) {
            let totalActiveTaskCount = taskCount;
            let currentTask = Number(context.currentTaskNo) - 1;
            let percentage = currentTask/(totalActiveTaskCount) * 100;
            return `${Math.round(percentage)}% COMPLETE`;
        } else {
            return '0% COMPLETE'
        }
    }

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    return(
        <div className={'container'}>
            <SideNav/>
            <div className={'app-page'}>
                <div className={'home'}>
                    {cards}
                </div>
                <MobileHeader/>
                <BottomNav/>
            </div>

            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
                message={alertMsg}
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />

        </div>
    )
}

export default Home;